// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── TagesablaufVerwaltung ─── */

/* Tages-Tabs (wie SpeiseplanVerwaltung) */
.ta-admin-tabs {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding: 4px 0 16px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.ta-admin-tabs::-webkit-scrollbar {
  display: none;
}

.ta-admin-tab {
  flex: 0 0 auto;
  padding: 8px 14px;
  border-radius: 20px;
  border: 2px solid #0074b3;
  background-color: transparent;
  color: #0074b3;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 0.95em;
  white-space: nowrap;
  margin: 0;
  width: auto;
  min-height: auto;
  display: flex;
  align-items: center;
  gap: 6px;
}

.ta-admin-tab:hover {
  background-color: rgba(0, 116, 179, 0.1);
  opacity: 1;
}

.ta-admin-tab.active {
  background-color: #0074b3;
  color: #fff;
  border-color: #0074b3;
}

/* Punkt an Tagen, für die schon ein Tagesablauf existiert */
.ta-tab-punkt {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background-color: #6ab023;
  display: inline-block;
}

.ta-admin-tab.active .ta-tab-punkt {
  background-color: #fff;
}

/* ─── Leerer Tag: anlegen ─── */

.ta-leer-panel {
  background-color: rgba(180, 200, 130, 0.3);
  border-radius: 14px;
  padding: 18px 20px;
  text-align: left;
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 16px;
}

.ta-leer-hinweis,
.ta-leer-oder {
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 0.95em;
  margin: 0;
}

.ta-leer-oder {
  font-style: italic;
  font-size: 0.85em;
}

.ta-kopieren-zeile {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: wrap;
}

.ta-kopieren-zeile select {
  padding: 10px;
  border-radius: 10px;
  border: 2px solid #0074b3;
  background-color: #fff;
  color: #0074b3;
  font-family: 'Circular', sans-serif;
  font-size: 0.95em;
}

/* Blaue Aktions-Buttons (eigenständig, unabhängig von anderen Seiten) */
.ta-leer-panel .btn-save,
.ta-kopieren-zeile .btn-save,
.ta-neue-zeile .btn-save {
  background-color: #0074b3;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 0.95em;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0;
  width: auto;
  min-height: auto;
}

.ta-leer-panel .btn-save:hover,
.ta-kopieren-zeile .btn-save:hover,
.ta-neue-zeile .btn-save:hover {
  background-color: #005f94;
}

.ta-leer-panel .btn-save:disabled,
.ta-kopieren-zeile .btn-save:disabled,
.ta-neue-zeile .btn-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ta-leer-panel .btn-save .material-symbols-outlined,
.ta-neue-zeile .btn-save .material-symbols-outlined {
  font-size: 1.2rem;
}

/* ─── Zeilen-Karten ─── */

.ta-zeilen-liste {
  display: flex;
  flex-direction: column;
  gap: 14px;
  animation: taFadeIn 0.2s ease;
}

@keyframes taFadeIn {
  from { opacity: 0; transform: translateY(6px); }
  to   { opacity: 1; transform: translateY(0); }
}

.ta-zeile-card {
  background-color: rgba(180, 200, 130, 0.3);
  border-radius: 14px;
  padding: 14px 16px;
  text-align: left;
}

.ta-zeile-kopf {
  display: flex;
  align-items: center;
  gap: 8px;
}

.ta-zeile-verschieben {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.ta-zeile-name {
  flex: 1 1;
  background-color: rgba(180, 200, 130, 0.5);
  border: none;
  padding: 8px 10px;
  border-radius: 5px;
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 1em;
  font-weight: bold;
  margin: 0;
  min-width: 0;
}

/* Icon-Buttons */
.ta-icon-btn {
  background-color: transparent;
  border: none;
  color: #0074b3;
  cursor: pointer;
  padding: 2px;
  margin: 0;
  width: auto;
  min-height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
}

.ta-icon-btn .material-symbols-outlined {
  font-size: 1.25rem;
}

.ta-icon-btn:hover {
  background-color: rgba(0, 116, 179, 0.12);
  opacity: 1;
}

.ta-icon-btn:disabled {
  opacity: 0.25;
  cursor: not-allowed;
}

.ta-icon-btn-rot {
  color: #c0392b;
}

.ta-icon-btn-rot:hover {
  background-color: rgba(192, 57, 43, 0.12);
}

/* Speichern-Button hervorheben, wenn es ungespeicherte Änderungen gibt */
.ta-icon-btn-gruen {
  color: #fff;
  background-color: #6ab023;
}

.ta-icon-btn-gruen:hover {
  background-color: #578f1d;
}

/* ─── Mini-Vorschau (7–24 Uhr) ─── */

.ta-vorschau {
  position: relative;
  height: 14px;
  margin: 10px 0 8px;
  border-radius: 4px;
  background-color: rgba(255, 255, 255, 0.7);
  /* Stundenraster der Vorschau: 17 Stunden */
  background-image: repeating-linear-gradient(
    to right,
    rgba(0, 116, 179, 0.18) 0,
    rgba(0, 116, 179, 0.18) 1px,
    transparent 1px,
    transparent calc(100% / 17)
  );
  overflow: hidden;
}

.ta-vorschau-slot {
  position: absolute;
  top: 2px;
  bottom: 2px;
  border-radius: 2px;
}

/* ─── Slot-Editor ─── */

.ta-slot-editor {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  padding: 8px 0;
  border-top: 1px solid rgba(100, 130, 2, 0.2);
}

.ta-slot-editor input[type="time"] {
  background-color: rgba(180, 200, 130, 0.5);
  border: none;
  padding: 6px 8px;
  border-radius: 5px;
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 0.9em;
  margin: 0;
  width: auto;
}

.ta-bis {
  color: var(--dunkelgruen);
}

.ta-farben {
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
}

.ta-farbe {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
  padding: 0;
  margin: 0;
  min-height: auto;
}

.ta-farbe:hover {
  opacity: 0.8;
}

.ta-farbe.active {
  border-color: #333;
  transform: scale(1.15);
}

.ta-slot-label-input {
  flex: 1 1;
  min-width: 120px;
  background-color: rgba(180, 200, 130, 0.5);
  border: none;
  padding: 6px 8px;
  border-radius: 5px;
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 0.9em;
  margin: 0;
}

.ta-slot-label-input::placeholder {
  color: var(--primary-dark);
  opacity: 0.8;
}

/* Slot hinzufügen */
.ta-slot-hinzufuegen {
  background-color: transparent;
  border: 2px dashed #0074b3;
  color: #0074b3;
  border-radius: 10px;
  padding: 6px 12px;
  font-size: 0.9em;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  margin: 8px 0 0;
  width: auto;
  min-height: auto;
}

.ta-slot-hinzufuegen:hover {
  background-color: rgba(0, 116, 179, 0.08);
  opacity: 1;
}

.ta-slot-hinzufuegen .material-symbols-outlined {
  font-size: 1.1rem;
}

/* ─── Neue Zeile / Tag löschen ─── */

.ta-neue-zeile {
  display: flex;
  gap: 8px;
  margin-top: 16px;
  align-items: center;
}

.ta-neue-zeile input[type="text"] {
  flex: 1 1;
  background-color: rgba(180, 200, 130, 0.5);
  border: none;
  padding: 10px;
  border-radius: 5px;
  color: var(--dunkelgruen);
  font-family: 'Circular', sans-serif;
  font-size: 1em;
  margin: 0;
}

.ta-neue-zeile input[type="text"]::placeholder {
  color: var(--primary-dark);
  opacity: 1;
}

.ta-neue-zeile .btn-save {
  white-space: nowrap;
}

.ta-tag-loeschen {
  background-color: transparent;
  border: 2px solid #c0392b;
  color: #c0392b;
  border-radius: 10px;
  padding: 8px 14px;
  font-size: 0.9em;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  margin: 20px auto 0;
  width: auto;
  min-height: auto;
}

.ta-tag-loeschen:hover {
  background-color: #c0392b;
  color: #fff;
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/listen/tagesablauf/TagesablaufVerwaltung.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC,0CAA0C;AAC1C;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,wCAAwC;EACxC,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,qBAAqB;AACvB;;AAEA,4DAA4D;AAC5D;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,gCAAgC;;AAEhC;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,mCAAmC;EACnC,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA,wEAAwE;AACxE;;;EAGE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA,0BAA0B;;AAE1B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,6BAA6B;AAC/B;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,0CAA0C;EAC1C,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,cAAc;EACd,iBAAiB;EACjB,SAAS;EACT,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,6BAA6B;EAC7B,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,yEAAyE;AACzE;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qCAAqC;;AAErC;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;EAC3C;;;;;;GAMC;EACD,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA,wBAAwB;;AAExB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,4CAA4C;AAC9C;;AAEA;EACE,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;EAChB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,0CAA0C;EAC1C,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA,qCAAqC;;AAErC;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,cAAc;EACd,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,UAAU;AACZ","sourcesContent":["/* ─── TagesablaufVerwaltung ─── */\n\n/* Tages-Tabs (wie SpeiseplanVerwaltung) */\n.ta-admin-tabs {\n  display: flex;\n  gap: 6px;\n  overflow-x: auto;\n  padding: 4px 0 16px;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.ta-admin-tabs::-webkit-scrollbar {\n  display: none;\n}\n\n.ta-admin-tab {\n  flex: 0 0 auto;\n  padding: 8px 14px;\n  border-radius: 20px;\n  border: 2px solid #0074b3;\n  background-color: transparent;\n  color: #0074b3;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 0.95em;\n  white-space: nowrap;\n  margin: 0;\n  width: auto;\n  min-height: auto;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.ta-admin-tab:hover {\n  background-color: rgba(0, 116, 179, 0.1);\n  opacity: 1;\n}\n\n.ta-admin-tab.active {\n  background-color: #0074b3;\n  color: #fff;\n  border-color: #0074b3;\n}\n\n/* Punkt an Tagen, für die schon ein Tagesablauf existiert */\n.ta-tab-punkt {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background-color: #6ab023;\n  display: inline-block;\n}\n\n.ta-admin-tab.active .ta-tab-punkt {\n  background-color: #fff;\n}\n\n/* ─── Leerer Tag: anlegen ─── */\n\n.ta-leer-panel {\n  background-color: rgba(180, 200, 130, 0.3);\n  border-radius: 14px;\n  padding: 18px 20px;\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.ta-leer-hinweis,\n.ta-leer-oder {\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.95em;\n  margin: 0;\n}\n\n.ta-leer-oder {\n  font-style: italic;\n  font-size: 0.85em;\n}\n\n.ta-kopieren-zeile {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.ta-kopieren-zeile select {\n  padding: 10px;\n  border-radius: 10px;\n  border: 2px solid #0074b3;\n  background-color: #fff;\n  color: #0074b3;\n  font-family: 'Circular', sans-serif;\n  font-size: 0.95em;\n}\n\n/* Blaue Aktions-Buttons (eigenständig, unabhängig von anderen Seiten) */\n.ta-leer-panel .btn-save,\n.ta-kopieren-zeile .btn-save,\n.ta-neue-zeile .btn-save {\n  background-color: #0074b3;\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  padding: 10px 16px;\n  font-size: 0.95em;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin: 0;\n  width: auto;\n  min-height: auto;\n}\n\n.ta-leer-panel .btn-save:hover,\n.ta-kopieren-zeile .btn-save:hover,\n.ta-neue-zeile .btn-save:hover {\n  background-color: #005f94;\n}\n\n.ta-leer-panel .btn-save:disabled,\n.ta-kopieren-zeile .btn-save:disabled,\n.ta-neue-zeile .btn-save:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ta-leer-panel .btn-save .material-symbols-outlined,\n.ta-neue-zeile .btn-save .material-symbols-outlined {\n  font-size: 1.2rem;\n}\n\n/* ─── Zeilen-Karten ─── */\n\n.ta-zeilen-liste {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n  animation: taFadeIn 0.2s ease;\n}\n\n@keyframes taFadeIn {\n  from { opacity: 0; transform: translateY(6px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n\n.ta-zeile-card {\n  background-color: rgba(180, 200, 130, 0.3);\n  border-radius: 14px;\n  padding: 14px 16px;\n  text-align: left;\n}\n\n.ta-zeile-kopf {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.ta-zeile-verschieben {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.ta-zeile-name {\n  flex: 1;\n  background-color: rgba(180, 200, 130, 0.5);\n  border: none;\n  padding: 8px 10px;\n  border-radius: 5px;\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 1em;\n  font-weight: bold;\n  margin: 0;\n  min-width: 0;\n}\n\n/* Icon-Buttons */\n.ta-icon-btn {\n  background-color: transparent;\n  border: none;\n  color: #0074b3;\n  cursor: pointer;\n  padding: 2px;\n  margin: 0;\n  width: auto;\n  min-height: auto;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n}\n\n.ta-icon-btn .material-symbols-outlined {\n  font-size: 1.25rem;\n}\n\n.ta-icon-btn:hover {\n  background-color: rgba(0, 116, 179, 0.12);\n  opacity: 1;\n}\n\n.ta-icon-btn:disabled {\n  opacity: 0.25;\n  cursor: not-allowed;\n}\n\n.ta-icon-btn-rot {\n  color: #c0392b;\n}\n\n.ta-icon-btn-rot:hover {\n  background-color: rgba(192, 57, 43, 0.12);\n}\n\n/* Speichern-Button hervorheben, wenn es ungespeicherte Änderungen gibt */\n.ta-icon-btn-gruen {\n  color: #fff;\n  background-color: #6ab023;\n}\n\n.ta-icon-btn-gruen:hover {\n  background-color: #578f1d;\n}\n\n/* ─── Mini-Vorschau (7–24 Uhr) ─── */\n\n.ta-vorschau {\n  position: relative;\n  height: 14px;\n  margin: 10px 0 8px;\n  border-radius: 4px;\n  background-color: rgba(255, 255, 255, 0.7);\n  /* Stundenraster der Vorschau: 17 Stunden */\n  background-image: repeating-linear-gradient(\n    to right,\n    rgba(0, 116, 179, 0.18) 0,\n    rgba(0, 116, 179, 0.18) 1px,\n    transparent 1px,\n    transparent calc(100% / 17)\n  );\n  overflow: hidden;\n}\n\n.ta-vorschau-slot {\n  position: absolute;\n  top: 2px;\n  bottom: 2px;\n  border-radius: 2px;\n}\n\n/* ─── Slot-Editor ─── */\n\n.ta-slot-editor {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  padding: 8px 0;\n  border-top: 1px solid rgba(100, 130, 2, 0.2);\n}\n\n.ta-slot-editor input[type=\"time\"] {\n  background-color: rgba(180, 200, 130, 0.5);\n  border: none;\n  padding: 6px 8px;\n  border-radius: 5px;\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.9em;\n  margin: 0;\n  width: auto;\n}\n\n.ta-bis {\n  color: var(--dunkelgruen);\n}\n\n.ta-farben {\n  display: flex;\n  gap: 4px;\n  flex-wrap: wrap;\n}\n\n.ta-farbe {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  cursor: pointer;\n  padding: 0;\n  margin: 0;\n  min-height: auto;\n}\n\n.ta-farbe:hover {\n  opacity: 0.8;\n}\n\n.ta-farbe.active {\n  border-color: #333;\n  transform: scale(1.15);\n}\n\n.ta-slot-label-input {\n  flex: 1;\n  min-width: 120px;\n  background-color: rgba(180, 200, 130, 0.5);\n  border: none;\n  padding: 6px 8px;\n  border-radius: 5px;\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 0.9em;\n  margin: 0;\n}\n\n.ta-slot-label-input::placeholder {\n  color: var(--primary-dark);\n  opacity: 0.8;\n}\n\n/* Slot hinzufügen */\n.ta-slot-hinzufuegen {\n  background-color: transparent;\n  border: 2px dashed #0074b3;\n  color: #0074b3;\n  border-radius: 10px;\n  padding: 6px 12px;\n  font-size: 0.9em;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  margin: 8px 0 0;\n  width: auto;\n  min-height: auto;\n}\n\n.ta-slot-hinzufuegen:hover {\n  background-color: rgba(0, 116, 179, 0.08);\n  opacity: 1;\n}\n\n.ta-slot-hinzufuegen .material-symbols-outlined {\n  font-size: 1.1rem;\n}\n\n/* ─── Neue Zeile / Tag löschen ─── */\n\n.ta-neue-zeile {\n  display: flex;\n  gap: 8px;\n  margin-top: 16px;\n  align-items: center;\n}\n\n.ta-neue-zeile input[type=\"text\"] {\n  flex: 1;\n  background-color: rgba(180, 200, 130, 0.5);\n  border: none;\n  padding: 10px;\n  border-radius: 5px;\n  color: var(--dunkelgruen);\n  font-family: 'Circular', sans-serif;\n  font-size: 1em;\n  margin: 0;\n}\n\n.ta-neue-zeile input[type=\"text\"]::placeholder {\n  color: var(--primary-dark);\n  opacity: 1;\n}\n\n.ta-neue-zeile .btn-save {\n  white-space: nowrap;\n}\n\n.ta-tag-loeschen {\n  background-color: transparent;\n  border: 2px solid #c0392b;\n  color: #c0392b;\n  border-radius: 10px;\n  padding: 8px 14px;\n  font-size: 0.9em;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  margin: 20px auto 0;\n  width: auto;\n  min-height: auto;\n}\n\n.ta-tag-loeschen:hover {\n  background-color: #c0392b;\n  color: #fff;\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
